var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash-notice",class:_vm.background},[_c('div',{staticClass:"flash-notice__icon",class:`align-${_vm.alignIcon}`},[_vm._t("icon")],2),_c('div',{staticClass:"flash-notice__message",class:_vm.text},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }